import { useCustomTranslation } from "../../helpers/translateHelpers";
import Popup from "../popup/Popup";
import { Title } from "../layout";
import FilterForm from "./FilterForm";
import { SelectItem } from "../select/Select";
import { FilterItem } from "./models";
import Icon from "../icon/Icon";
import { useMemo } from "react";

interface FilterProps {
  selectedFitlers?: Record<string, SelectItem[]>;
  updateFilters: (selectedFilters: Record<string, SelectItem[]>) => void;
  filters: FilterItem[];
}

const Filter = ({ updateFilters, selectedFitlers, filters }: FilterProps) => {
  const { tCommon } = useCustomTranslation();

  const filtersCount = useMemo(
    () =>
      selectedFitlers
        ? Object.keys(selectedFitlers).filter(
            (key) => selectedFitlers?.[key].length,
          ).length
        : 0,
    [selectedFitlers],
  );

  const getFiltersCountBadge = () => {
    if (filtersCount > 0) {
      return (
        <div className="bg-gray flex h-[20px] w-[20px] items-center justify-center rounded-full">
          <span>{filtersCount}</span>
        </div>
      );
    }
  };

  return (
    <Popup
      position="bottom center"
      trigger={(isOpen: boolean) => (
        <div className="border-gray-accent shadow-gray-default hover:bg-gray flex cursor-pointer items-center justify-between gap-2.5 rounded-[10px] border px-5 py-2.5 text-[14px]/[20px] font-medium tracking-[-0.14px]">
          <span className="">{tCommon("filter_button")}</span>
          {getFiltersCountBadge()}
          {isOpen ? (
            <Icon name="close" size="small" />
          ) : (
            <Icon name="filter-funnel" size="small" />
          )}
        </div>
      )}
      className="Filter"
    >
      {() => (
        <div className="w-[280px] p-8">
          {/* Fake input is a focus trap because of popup autofocus first input on open and it causing weird behavior in Filter selects */}
          <input type="hidden" role="none" />
          <Title size="default" title={tCommon("filter_settings")} />
          <FilterForm
            selectedFitlers={selectedFitlers}
            updateFilters={updateFilters}
            filters={filters}
            resetDisabled={filtersCount === 0}
          />
        </div>
      )}
    </Popup>
  );
};

export default Filter;
